import * as _ from 'underscore';
import { appStore } from '../../app/AppStore';
import { siteUrlsSelector } from '../../app/selectors/SiteUrlsSelectors';
import { TagsHelper } from '../helpers/TagsInputHelper';
import { Module } from '../Module';
import { ITagWithCount } from './tbTagsInput';

// This directive displays tags input with edit buttons.  When clicking on the the edit button,
// the tags input and confirmation buttons appear for editing

interface IEditableTagsAttributes extends ng.IAttributes {
  ngModel: string;
  onBeforeSave: string;
  buttonContainer?: string;
  tagFilterState: string;
  readonly?: string;
}

export interface IEditableTagsScope extends ng.IScope {
  onBeforeSave: (locals: { newTags: string[] }) => ng.IPromise<any>;
  buttonContainer: string;
  tagFilterState: string;

  // private

  // states
  editMode: boolean;
  readonly: boolean;
  busy: boolean;

  // variables
  tagsWithCounts: ITagWithCount[];
  newTag: string;

  // methods
  edit(): void;
  save(): void;
  cancel(): void;

  displayTagHtml(tag: string): string;
  filterByTag(state: string, tag: string): void;
}

Module.instance().directive('tbEditableTags', <any[]>[
  '$location',
  ($location: ng.ILocationService) => {
    return {
      restrict: 'E',
      replace: true,
      templateUrl: 'editableTags.html',
      scope: {
        onBeforeSave: '&'
      },
      require: 'ngModel',
      link: ($scope: IEditableTagsScope, element: JQuery, attrs: IEditableTagsAttributes, ngModelCtrl: ng.INgModelController) => {

        ngModelCtrl.$render = () => {
          $scope.tagsWithCounts = _.map(ngModelCtrl.$modelValue, (tag: string) => {
            return { name: tag };
          });
        };

        attrs.$observe('readonly', (attrReadonly: any) => {
          $scope.readonly = !!attrReadonly;
          element.toggleClass('tb-readonly', $scope.readonly);
        });

        $scope.filterByTag = (tag: string) => {
          const urls = siteUrlsSelector(appStore.getState());
          let newUrl = '';
          if (attrs.tagFilterState === 'datasources') {
            newUrl = urls.datasourcesPath();
          } else if (attrs.tagFilterState === 'workbooks') {
            newUrl = urls.workbooksPath();
          }
          if (newUrl) {
            $location.url(newUrl).search('tag', TagsHelper.unquote(tag));
          }
        };

        $scope.edit = () => {
          $scope.editMode = true;
          $scope.busy = false;
          $scope.newTag = '';
        };

        $scope.save = () => {
          $scope.busy = true;
          let newTags = _.map($scope.tagsWithCounts, (tag: ITagWithCount) => tag.name);

          if($scope.newTag) newTags = _.union(newTags, [ TagsHelper.quote($scope.newTag) ]);

          $scope.onBeforeSave({ newTags: newTags }).then(
            // Success
            () => {
              ngModelCtrl.$setViewValue(newTags);
              ngModelCtrl.$render();
              $scope.editMode = false;
              $scope.busy = false;
              $scope.newTag = '';
            },
            // Error
            () => {
              // TODO: show error message
              $scope.busy = false;
            }
          );
        };

        $scope.cancel = () => {
          $scope.editMode = false;
          $scope.busy = false;
          $scope.newTag = '';
          ngModelCtrl.$render(); // Resets tagsWithCounts to match the current model
        };

        if (attrs.buttonContainer) {
          element.find('.tb-editable-tags-input-buttons').appendTo($(attrs.buttonContainer));
        }

        $scope.displayTagHtml = TagsHelper.displayTagHtml;
      }
    };
  }
]);
